// react
import React from 'react';

// mui
import { Box, ButtonBase } from '@mui/material';

export interface ColourSwatchProps {
  colour: string;
  isSelected: boolean;
  onClick: () => void;
}

/**
 * ColourSwatch renders a circular colour swatch with a selected ring state.
 */
export const ColourSwatch = ({
  colour,
  isSelected,
  onClick,
}: ColourSwatchProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{ borderRadius: '50%', p: 0.5 }}
      aria-label={`Colour #${colour}`}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: `#${colour}`,
          outline: isSelected ? '3px solid' : 'none',
          outlineColor: 'primary.main',
          outlineOffset: 2,
          transition: 'outline 0.15s',
        }}
      />
    </ButtonBase>
  );
};

ColourSwatch.displayName = 'ColourSwatch';
export default ColourSwatch;
